var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white border-vectric border-4 rounded-t-2xl rounded-br-2xl"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }